"use client";

import { useState } from 'react';
import styles from "@/app/[locale]/services/[slug]/service-detail.module.css";
import ContactModal from "@/components/contact/ContactModal";

export default function ServiceSidebar({ translations, isRtl }) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <aside className={styles.sidebar}>
            <div className={styles.contactCard}>
                <h3>{isRtl ? 'مهتم بهذه الخدمة؟' : 'Interested in this service?'}</h3>
                <p>
                    {isRtl
                        ? 'تواصل معنا اليوم لمناقشة كيف يمكننا مساعدتك في تحقيق أهدافك.'
                        : 'Contact us today to discuss how we can help you achieve your goals.'}
                </p>
                <button
                    onClick={() => setIsModalOpen(true)}
                    className={styles.contactButton}
                >
                    {isRtl ? 'احصل على استشارة' : 'Get a Consultation'}
                </button>
            </div>

            <ContactModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                translations={translations}
                title={isRtl ? 'احصل على استشارة' : 'Get a Consultation'}
            />
        </aside>
    );
}
